import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LangToggle({ className = '' }) {
  const { i18n } = useTranslation();
  const lang = i18n.language || 'en';

  const toggleLang = () => {
    const newLang = lang.startsWith('en') ? 'zh' : 'en';
    i18n.changeLanguage(newLang);
    localStorage.setItem('ets_lang', newLang);
  };

  return (
    <div 
      className={className}
      onClick={toggleLang}
      style={{
        display: 'flex',
        alignItems: 'center',
        background: '#f4f4f4',
        borderRadius: 30,
        padding: 4,
        position: 'relative',
        cursor: 'pointer',
        width: 90,
        height: 32,
        boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)',
        userSelect: 'none'
      }}
      title={lang.startsWith('en') ? 'Switch to Traditional Chinese' : 'Switch to English'}
    >
      <div 
        style={{
          position: 'absolute',
          top: 4,
          bottom: 4,
          left: 4,
          width: 41,
          background: '#fff',
          borderRadius: 20,
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
          transform: lang.startsWith('zh') ? 'translateX(41px)' : 'translateX(0)',
          transition: 'transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)'
        }}
      />
      <div style={{ flex: 1, textAlign: 'center', zIndex: 1, fontSize: 11, fontWeight: 700, color: lang.startsWith('en') ? '#111' : '#888', transition: 'color 0.3s' }}>
        EN
      </div>
      <div style={{ flex: 1, textAlign: 'center', zIndex: 1, fontSize: 11, fontWeight: 700, color: lang.startsWith('zh') ? '#111' : '#888', transition: 'color 0.3s' }}>
        繁中
      </div>
    </div>
  );
}
